// DEMO DATA — SIMULATION ONLY. Never presented as real proofs.
export const demoProofs = [
    {
        proofId: "ACTRA-8F72-91AC",
        task: "Solar Infrastructure Inspection",
        taskId: "TASK #10417",
        agent: "AG-0421",
        agentType: "AI AGENT",
        status: "VERIFIED",
        action: "Autonomous thermal scan of a 412-panel solar array; anomalies geo-tagged and logged.",
        evidence: [
            { type: "GPS VERIFIED", pass: true },
            { type: "IMAGE VERIFIED", pass: true },
            { type: "SENSOR VERIFIED", pass: true },
            { type: "TIMESTAMP VERIFIED", pass: true },
        ],
        verification: "4 / 4 EVIDENCE ITEMS ACCEPTED",
        reputation: "+0.12",
        settlement: "25 USDC",
        hash: "8F72 91AC E3B0 C442 97FD A1C0",
    },
    {
        proofId: "ACTRA-4C1D-77E9",
        task: "Warehouse Inventory Cycle Count",
        taskId: "TASK #10402",
        agent: "AG-0117",
        agentType: "ROBOT",
        status: "VERIFIED",
        action: "Aisle-by-aisle cycle count of 1,204 SKUs with signed navigation telemetry.",
        evidence: [
            { type: "DEVICE SIGNATURE VERIFIED", pass: true },
            { type: "IMAGE VERIFIED", pass: true },
            { type: "TELEMETRY VERIFIED", pass: true },
            { type: "TIMESTAMP VERIFIED", pass: true },
        ],
        verification: "4 / 4 EVIDENCE ITEMS ACCEPTED",
        reputation: "+0.09",
        settlement: "120 USDC",
        hash: "4C1D 77E9 08B2 6F51 3DA8 44E0",
    },
    {
        proofId: "ACTRA-B2A6-03D5",
        task: "Campus Route 7 Last-Mile Delivery",
        taskId: "TASK #10440",
        agent: "AG-0093",
        agentType: "ROBOT",
        status: "VERIFIED",
        action: "Nine-stop delivery route completed with continuous GPS trace.",
        evidence: [
            { type: "GPS VERIFIED", pass: true },
            { type: "TIMESTAMP VERIFIED", pass: true },
            { type: "DEVICE SIGNATURE VERIFIED", pass: true },
        ],
        verification: "3 / 3 EVIDENCE ITEMS ACCEPTED",
        reputation: "+0.12",
        settlement: "18 USDC",
        hash: "B2A6 03D5 5E19 8C77 2F40 91AB",
    },
    {
        proofId: "ACTRA-61E8-9B24",
        task: "Inference Endpoint Stress Test",
        taskId: "TASK #10412",
        agent: "AG-0366",
        agentType: "SOFTWARE AGENT",
        status: "VERIFIED",
        action: "Five-stage load profile executed against ML inference endpoint; full request logs captured.",
        evidence: [
            { type: "API LOGS VERIFIED", pass: true },
            { type: "EXECUTION TRACE VERIFIED", pass: true },
            { type: "TIMESTAMP VERIFIED", pass: true },
        ],
        verification: "3 / 3 EVIDENCE ITEMS ACCEPTED",
        reputation: "+0.10",
        settlement: "90 USDC",
        hash: "61E8 9B24 C705 12F3 88AD 40B9",
    },
];
